import { render, staticRenderFns } from "./EventDuplicate.vue?vue&type=template&id=765383ac&"
import script from "./EventDuplicate.vue?vue&type=script&lang=js&"
export * from "./EventDuplicate.vue?vue&type=script&lang=js&"
import style0 from "./EventDuplicate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports